import axios from 'axios'
import $store from '@/vuex/store'
import {
  getToken
} from '@/utils/auth'
// create an axios instance

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL // VUE_APP_BASE_LOGIN_URL
})
service.interceptors.request.use(config => {
  const token = getToken()
  // post 请求统一添加userId参数
  if ((config.method === 'post' || config.method === 'delete') && config.data) {
    // 如果是post请求，没有
    if (!$store.state.userInfo.userId || !token) {
      $store.commit('SET_LOGOUT')
    }
    if (!config.data['userId']) config.data['userId'] = $store.state.userInfo.userId
    // console.log(config)
  }
  config.headers['Authorization'] = token || ''
  return config
}, error => Promise.reject(error))
// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data
    if (res.status * 1 === 401 || response.data.status * 1 === 400) {
      console.log(res.status)
      // Message.error('用户登录信息已失效，请登录！')
      $store.commit('SET_LOGOUT')
    }
    return res
  },
  (error) => {
    if ((error.response.status * 1 === 401 || error.response.status * 1 === 400 || error.response.status * 1 === 405 || error.response.status * 1 === 408 || error.response.status * 1 === 609)) {
      // $store.commit('SET_LOGOUT')
    }
    return Promise.reject(error)
  }
)

export default service
